export const FREQUENCY = [
  { id: '1M', displayValue: '1M' },
  { id: '2M', displayValue: '2M' },
  { id: '3M', displayValue: '3M' },
  { id: '6M', displayValue: '6M' },
  { id: '1Y', displayValue: '1Y' },
  { id: '2Y', displayValue: '2Y' },
  { id: 'AT_MATURITY', displayValue: 'At Maturity' },
];

export const ZERO_BUSINESS_DAYS = {
  id: '0B',
  displayValue: '0B',
}

export enum FrequencyKeys {
  AT_MATURITY = 'AT_MATURITY',
}